<template>

	<div class="row">
		<div class="col-6 col-md-6">
			<div class="card">
				<div class="card-header">
					View Per Days
				</div>
				<div class="card-body">
					<div class="d-flex align-items-center">
						<div class="ms-auto lh-1">
							<div class="dropdown">
								<a class="dropdown-toggle text-muted" href="javascript:void(0)" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<span>{{ post_week_label }}</span>
								</a>
	    						<div class="dropdown-menu dropdown-menu-end">
	    							<a :class="getPostWeekactiveClass(1)" href="javascript:void(0)" v-on:click="getPostWeektoggleActive(1)">Last 7 days</a>
	    							<a :class="getPostWeekactiveClass(2)" href="javascript:void(0)" v-on:click="getPostWeektoggleActive(2)">Last 14 days</a>
	    							<a :class="getPostWeekactiveClass(3)" href="javascript:void(0)" v-on:click="getPostWeektoggleActive(3)">Last 21 days</a>
	    							<a :class="getPostWeekactiveClass(4)" href="javascript:void(0)" v-on:click="getPostWeektoggleActive(4)">Last 28 days</a>
	    						</div>
							</div>
						</div>
					</div>
					<apexchart id="chart1" height="240" type="line" :options="options1" :series="series1"></apexchart>
				</div>
			</div>
		</div>
		<div class="col-6 col-md-6">
			<div class="card">
				<div class="card-header">
					View Per Month
				</div>
				<div class="card-body">
					<div class="d-flex align-items-center">
						<div class="ms-auto lh-1">
	    					<div class="dropdown">
	    						<a class="dropdown-toggle text-muted" href="javascript:void(0)" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
	    							<span>{{ post_month_label }}</span>
	    						</a>
	    						<div class="dropdown-menu dropdown-menu-end">
	    							<a :class="getPostMonthactiveClass(1)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(1)">All Months</a>
	    							<a :class="getPostMonthactiveClass(2)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(2)">January</a>
	    							<a :class="getPostMonthactiveClass(3)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(3)">February</a>
	    							<a :class="getPostMonthactiveClass(4)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(4)">March</a>
	    							<a :class="getPostMonthactiveClass(5)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(5)">April</a>
	    							<a :class="getPostMonthactiveClass(6)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(6)">May</a>
	    							<a :class="getPostMonthactiveClass(7)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(7)">Jun</a>
	    							<a :class="getPostMonthactiveClass(8)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(8)">July</a>
	    							<a :class="getPostMonthactiveClass(9)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(9)">August</a>
	    							<a :class="getPostMonthactiveClass(10)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(10)">Spetember</a>
	    							<a :class="getPostMonthactiveClass(11)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(11)">October</a>
	    							<a :class="getPostMonthactiveClass(12)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(12)">November</a>
	    							<a :class="getPostMonthactiveClass(13)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(13)">December</a>
	    						</div>
	    					</div>
						</div>
					</div>
					<apexchart id="chart2" height="240" type="area" :options="options2" :series="series2"></apexchart>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import VueApexCharts from 'vue-apexcharts'
	Vue.use(VueApexCharts)
	Vue.component('apexchart', VueApexCharts)

	export default {
		props: ['data'], 
		data() {
			return {
				post: [],
				post_week_default: 0,
				post_week_label: 'Last 7 days',
				post_month_default: 0,
				post_month_label: 'All Months',
				options1: {
				    chart: {
				        id: 'chart1',
				        toolbar: {
				        	show: false,
				        },
				    },
				    xaxis: {
				        categories: [],
				    },
				    tooltip: {
				        enabled: true,
				        theme: 'dark',
				    },
				},
				series1: [{
				    name: 'Total Views',
				    data: []
				}],
				options2: {
				    chart: {
				        id: 'chart2',
				        toolbar: {
				        	show: false,
				        },
				    },
				    xaxis: {
				        categories: []
				    },
				    tooltip: {
				        enabled: true,
				        theme: 'dark',
				    },
				},
				series2: [{
				    name: 'Total Views',
				    data: []
				}],
			};
		},
		mounted() {
			this.getPostViewWeekMonth();
		},
		methods: {
        	getPostViewWeekMonth() {
    			const form = new FormData();
    			form.append('post_id', this.data.post_id);
    			axios.post('/api/ajax/mod/posts/chart/all', form)
    			.then(res => {
    				this.options1 = {
    				    xaxis: {
    				        categories: res.data.data.chart_dates,
    				    }
    				};
    				this.series1 = [{
    				    data: res.data.data.chart_total,
    				}];
        	    	this.options2 = {
        	    	    xaxis: {
        	    	        categories: res.data.data.chart_months,
        	    	    }
        	    	};
        	    	if (res.data.data.total_post_monthly.length) {
        	    		if (res.data.data.total_post_monthly.length > 1) {
			    	    	this.series2 = [{
			    	    	    data: res.data.data.total_post_monthly[1].total
			    	    	}, {
				    		    data: res.data.data.total_post_monthly[0].total
			    	    	}];
        	    		}
	        	    	else {
			    	    	this.series2 = [{
			    	    	    data: res.data.data.total_post_monthly[0].total
			    	    	}];
	        	    	}
        	    	}    				
    		    })
    		    .catch(err => {  
    		    	console.log(err);                  
    		    }); 
        	},
        	getPostWeekactiveClass(segment) {
        		return segment == this.post_week_default ? 'dropdown-item active' : 'dropdown-item'
        	},
        	getPostWeektoggleActive (index) {
        		this.post_week_default = index;
        		if (index == 1) {
        			this.post_week_label = 'Last 7 days';
        		}
        		if (index == 2) {
        			this.post_week_label = 'Last 14 days';
        		}
        		if (index == 3) {
        			this.post_week_label = 'Last 21 days';
        		}
        		if (index == 4) {
        			this.post_week_label = 'Last 28 days';
        		}
    			const form = new FormData();
    			form.append('index', index);
    			form.append('post_id', this.data.post_id);
    			axios.post('/api/ajax/mod/posts/chart/weeks', form)
    			.then(res => {
    				this.options1 = {
    				    xaxis: {
    				        categories: res.data.data.chart_dates,
    				    }
    				};
    				this.series1 = [{
    				    data: res.data.data.chart_total,
    				}];
    		    })
    		    .catch(err => {  
    		    	console.log(err);                  
    		    }); 
        	},
        	getPostMonthactiveClass(segment) {
        		return segment == this.post_month_default ? 'dropdown-item active' : 'dropdown-item'
        	},
        	getPostMonthtoggleActive (index) {
        		this.post_month_default = index;
        		if (index == 1) {
        			this.post_month_label = 'All Months';
        		}
        		if (index == 2) {
        			this.post_month_label = 'January';
        		}
        		if (index == 3) {
        			this.post_month_label = 'February';
        		}
        		if (index == 4) {
        			this.post_month_label = 'March';
        		}
        		if (index == 5) {
        			this.post_month_label = 'April';
        		}
        		if (index == 6) {
        			this.post_month_label = 'May';
        		}
        		if (index == 7) {
        			this.post_month_label = 'June';
        		}
        		if (index == 8) {
        			this.post_month_label = 'July';
        		}
        		if (index == 9) {
        			this.post_month_label = 'August';
        		}
        		if (index == 10) {
        			this.post_month_label = 'September';
        		}
        		if (index == 11) {
        			this.post_month_label = 'October';
        		}
        		if (index == 12) {
        			this.post_month_label = 'November';
        		}
        		if (index == 13) {
        			this.post_month_label = 'December';
        		}
				const form = new FormData();
				form.append('index', index);
				form.append('post_id', this.data.post_id);
				axios.post('/api/ajax/mod/posts/chart/monthly', form)
				.then(res => {
        			this.options2 = {
        			    xaxis: {
        			        categories: res.data.data.chart_months,
        			    }
        			};
        	    	if (res.data.data.total_post_monthly.length > 1) {
		    	    	this.series2 = [{
		    	    	    data: res.data.data.total_post_monthly[1].total
		    	    	}, {
			    		    data: res.data.data.total_post_monthly[0].total
		    	    	}];
        	    	}
        	    	else {
		    	    	this.series2 = [{
		    	    	    data: res.data.data.total_post_monthly[0].total
		    	    	}];
        	    	}
			    })
			    .catch(err => {  
			    	console.log(err);                  
			    }); 	    	
        	}, 
		},
	}
</script>       